module.exports = __webpack_public_path__ + "img/daily-baby.832beda3.png";